import axios from "axios";
import { useEffect } from "react";
import { useContext, useState } from "react";
import { Container, Form, Row, Col, Button } from "react-bootstrap";
import { DatePicker } from "zaman";
import { MyContext } from "../helper/MyContext";
const FormData = require('form-data');

export default function Peymankaran(props) {
    const url = 'https://khpc.ir/sup-upload/';
    const [submit, setSubmit] = useState(false);
    const { user } = useContext(MyContext);
    const [firstData, setFirstData] = useState(true);
    const [resume, setResume] = useState([
        {
            id: Math.floor(Math.random() * 99999),
            area: '',
            employer: '',
            tasks: '',
            volume: '',
            type: '',
            start: '',
            end: ''
        }
    ]);

    useEffect(() => {
        let Mount = true;
        if (Mount) {
            let datao = new FormData();
            datao.append('userId', user);
            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://khpc.ir/api-supplier/api/getRequestByUserId',
                data: datao
            };

            axios.request(config)
                .then((response) => {
                    var dataLoaded = JSON.parse(response.data.data.dataPeymankaran);

                    setResume(dataLoaded.resume);
                    setAttachResume(dataLoaded.attachResume);
                    setLicense(dataLoaded.license);
                    setAttachLicense(dataLoaded.attachLicense);
                    setCars(dataLoaded.cars);
                    setAttachCars(dataLoaded.attachCars);
                    setDescriptionPeymankar(dataLoaded.descriptionPeymankar);
                    setFirstData(false)
                })
                .catch((error) => {
                    setFirstData(false)
                    // alert('تامین کننده گرامی، درخواست شما با خطا مواجه شد لطفا با پشتیبانی تماس بگیرید');
                });
        }
        return () => Mount = false;
    }, []);


    const updateRezume = (e, id) => {
        const { name, value } = e.target;
        const newState = resume.map(obj => {
            if (obj.id == id) {
                return { ...obj, [name]: value };
            }
            return obj;
        });
        setResume(newState);
    }

    const addResume = () => {
        setResume(oldState => [...oldState, {
            id: Math.floor(Math.random() * 99999),
            area: '',
            employer: '',
            tasks: '',
            volume: '',
            type: '',
            start: '',
            end: ''
        }]);
    }

    const removeResume = (id) => {
        var newValue = resume.filter(item => item.id !== id);
        setResume(newValue);
    }

    // end resume 
    const [attachResume, setAttachResume] = useState('');
    const [startAttachResume, setStartAttachResume] = useState(false);

    const UploadattachResume = async (event) => {
        if (event.target.files[0]?.type !== 'application/x-zip-compressed' && event.target.files[0]?.type !== 'application/zip') {
            alert('پسوند فایل بایستی zip باشد');
            return;
        }
        setStartAttachResume(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setAttachResume(res.data.name)
                setStartAttachResume(false)

            })
            .catch(err => {
                setStartAttachResume(false)
            })
    }

    ////

    const [license, setLicense] = useState([
        {
            id: Math.floor(Math.random() * 99999),
            type: '',
            company: '',
            date: '',
            work: ''
        }
    ]);


    const updateLicense = (e, id) => {
        const { name, value } = e.target;
        const newState = license.map(obj => {
            if (obj.id == id) {
                return { ...obj, [name]: value };
            }
            return obj;
        });
        setLicense(newState);
    }

    const addLicense = () => {
        setLicense(oldState => [...oldState, {
            id: Math.floor(Math.random() * 99999),
            type: '',
            company: '',
            date: '',
            work: ''
        }]);
    }

    const removeLicense = (id) => {
        var newValue = license.filter(item => item.id !== id);
        setLicense(newValue);
    }

    // end resume 
    const [attachLicense, setAttachLicense] = useState('');
    const [startAttachLicense, setStartAttachLicense] = useState(false);

    const UploadattachLicense = async (event) => {
        if (event.target.files[0]?.type !== 'application/x-zip-compressed' && event.target.files[0]?.type !== 'application/zip') {
            alert('پسوند فایل بایستی zip باشد');
            return;
        }
        setStartAttachLicense(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setAttachLicense(res.data.name)
                setStartAttachLicense(false)

            })
            .catch(err => {
                setStartAttachLicense(false)
            })
    }

    ////

    const [cars, setCars] = useState([
        {
            id: Math.floor(Math.random() * 99999),
            name: '',
            year: '',
            count: '',
            type: '',
            country: ''
        }
    ]);


    const updateCars = (e, id) => {
        const { name, value } = e.target;
        const newState = cars.map(obj => {
            if (obj.id == id) {
                return { ...obj, [name]: value };
            }
            return obj;
        });
        setCars(newState);
    }

    const addCars = () => {
        setCars(oldState => [...oldState, {
            id: Math.floor(Math.random() * 99999),
            name: '',
            year: '',
            count: '',
            type: '',
            country: ''
        }]);
    }

    const removeCars = (id) => {
        var newValue = cars.filter(item => item.id !== id);
        setCars(newValue);
    }

    // end resume 
    const [attachCars, setAttachCars] = useState('');
    const [startAttachCars, setStartAttachCars] = useState(false);

    const UploadattachCars = async (event) => {
        if (event.target.files[0]?.type !== 'application/x-zip-compressed' && event.target.files[0]?.type !== 'application/zip') {
            alert('پسوند فایل بایستی zip باشد');
            return;
        }
        setStartAttachCars(true)
        const formData = new FormData();
        formData.append("file", event.target.files[0]);
        formData.append("submit", true);

        await axios.post('https://khpc.ir/sup-upload/', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(res => {
                setAttachCars(res.data.name)
                setStartAttachCars(false)

            })
            .catch(err => {
                setStartAttachCars(false)
            })
    }

    const [descriptionPeymankar, setDescriptionPeymankar] = useState('');

    const changeStep = () => {
        setSubmit(true);
        if (descriptionPeymankar == '') {
            alert('فیلدهای مشخص شده الزامی هستند')
        } else {
            window.scrollTo(0, 0);
            var data = {
                resume: resume,
                attachResume: attachResume,
                license: license,
                attachLicense: attachLicense,
                cars: cars,
                attachCars: attachCars,
                descriptionPeymankar: descriptionPeymankar,
            };

            let dataForm = new FormData();
            dataForm.append('userId', user);
            dataForm.append('json', JSON.stringify(data));

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: 'https://khpc.ir/api-supplier/api/sendRequestStepPay',
                data: dataForm
            };

            axios.request(config)
                .then((response) => {
                    if (response.data.error) {
                        alert(response.data.message);
                    } else {
                        props.setData(data);
                        props.changeStep();
                    }
                    setSubmit(false);
                })
                .catch((error) => {
                    alert('تامین کننده گرامی، درخواست شما با خطا مواجه شد لطفا با پشتیبانی تماس بگیرید');
                    setSubmit(false);
                });
        }
    }

    const changeStepBack = () => {

        window.scrollTo(0, 0);
        props.backStep("3");

    }

    const handleSetDateRezumehStart = (date, id) => {
        if (!date) return;
        var newDate = new Date(date);
        var returnDate = `${newDate.getFullYear()}/${(newDate.getMonth() + 1) < 10 ? `0` + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)}/${newDate.getDate() < 10 ? `0` + newDate.getDate() : newDate.getDate()}`;
        let newArr = [...resume];
        newArr.find(item => item.id == id).start = returnDate;
        setResume(newArr);
    }
    const handleSetDateRezumehEnd = (date, id) => {
        if (!date) return;
        var newDate = new Date(date);
        var returnDate = `${newDate.getFullYear()}/${(newDate.getMonth() + 1) < 10 ? `0` + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)}/${newDate.getDate() < 10 ? `0` + newDate.getDate() : newDate.getDate()}`;
        let newArr = [...resume];
        newArr.find(item => item.id == id).end = returnDate;
        setResume(newArr);
    }

    const handleSetDateLicense = (date, id) => {
        if (!date) return;
        var newDate = new Date(date);
        var returnDate = `${newDate.getFullYear()}/${(newDate.getMonth() + 1) < 10 ? `0` + (newDate.getMonth() + 1) : (newDate.getMonth() + 1)}/${newDate.getDate() < 10 ? `0` + newDate.getDate() : newDate.getDate()}`;
        let newArr = [...license];
        newArr.find(item => item.id == id).date = returnDate;
        setLicense(newArr);
    }


    if (firstData) {
        return (
            <>
                <Container className="mt-2" >
                    <Row>
                        <Col xs="12">
                            در حال بارگزاری
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
    return (
        <Container className="mt-2" >
            <Row>
                <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                    <label className="text-g fw-bold">سوابق كاری</label>
                </Col>
                <Col xs={12} className="mt-4">

                    {
                        resume.map((item, index) => {
                            return (
                                <>
                                    <Row className="mb-3" key={index}>
                                        <Col xs={12} md={2}>
                                            <Form.Label style={{ fontSize: 10 }}>حوزه فعالیت</Form.Label>
                                            <Form.Control className="input-pmk" placeholder="حوزه فعاليت" name="area" value={item.area} onChange={(e) => updateRezume(e, item.id)} type="text" />
                                        </Col>
                                        <Col xs={12} md={2}>
                                            <Form.Label style={{ fontSize: 10 }}>کارفرما</Form.Label>
                                            <Form.Control className="input-pmk" placeholder="كارفرما" name="employer" value={item.employer} onChange={(e) => updateRezume(e, item.id)} type="text" />
                                        </Col>
                                        <Col xs={12} md={2}>
                                            <Form.Label style={{ fontSize: 10 }}>تعداد کار انجام شده</Form.Label>
                                            <Form.Control className="input-pmk" placeholder="تعداد كارانجام شده" name="tasks" value={item.tasks} onChange={(e) => updateRezume(e, item.id)} type="text" />
                                        </Col>
                                        <Col xs={12} md={2}>
                                            <Form.Label style={{ fontSize: 10 }}>حجم ریالی کارها</Form.Label>
                                            <Form.Control className="input-pmk" placeholder="حجم ريالی كارها" name="volume" value={item.volume} onChange={(e) => updateRezume(e, item.id)} type="text" />
                                        </Col>
                                        <Col xs={12} md={2}>
                                            <Form.Label style={{ fontSize: 10 }}>نوع قرارداد</Form.Label>
                                            <Form.Control className="input-pmk" placeholder="نوع قرارداد" name="type" value={item.type} onChange={(e) => updateRezume(e, item.id)} type="text" />
                                        </Col>
                                        <Col xs={12} md={2}>
                                            <Form.Label style={{ fontSize: 10 }}>سال شروع</Form.Label>
                                            <DatePicker inputClass={`datepicker`} direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDateRezumehStart(e.value, item.id)} />
                                        </Col>
                                        <Col xs={12} md={2}>
                                            <Form.Label style={{ fontSize: 10 }}>سال پايان</Form.Label>
                                            <DatePicker inputClass={`datepicker`} direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDateRezumehEnd(e.value, item.id)} />
                                        </Col>
                                    </Row>
                                    <Button onClick={(e) => removeResume(item.id)} variant="danger" size="sm">حذف</Button>
                                    <hr />
                                </>
                            )
                        })
                    }
                    <Row>
                        <Col xs={12} className="mt-4">
                            <Button onClick={(e) => addResume()} size="sm" >افزودن سابقه جدید</Button>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} className="mt-4">
                    <Form.Group controlId="formFile3" className="mb-4">
                        <Form.Label>مستندات سوابق کاری و گواهی حسن انجام کار :(فرمت zip)</Form.Label>
                        <Form.Control disabled={startAttachResume} onChange={(e) => UploadattachResume(e)} type="file" size="sm" accept=".zip" />
                    </Form.Group>
                    {
                        attachResume &&
                        <a target="_blank" rel="noreferrer" className="mb-2" href={url + attachResume} download>نمایش فایل</a>
                    }
                </Col>


                <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                    <label className="text-g fw-bold">لیسانس شرکتهای معتبر / نمایندگی / مشارکت</label>
                </Col>

                <Col xs={12} className="mt-4">

                    {
                        license.map((item, index) => {
                            return (
                                <>
                                    <Row className="mb-3" key={index}>
                                        <Col xs={12} md={3}>
                                            <Form.Label style={{ fontSize: 10 }}>زمینه فعالیت</Form.Label>
                                            <Form.Control className="input-pmk" placeholder="زمینه فعالیت" name="type" value={item.type} onChange={(e) => updateLicense(e, item.id)} type="text" />
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <Form.Label style={{ fontSize: 10 }}>نام شرکت اصلی اعطا کننده لیسانس</Form.Label>
                                            <Form.Control className="input-pmk" placeholder="نام شرکت اصلی اعطا کننده لیسانس" name="company" value={item.company} onChange={(e) => updateLicense(e, item.id)} type="text" />
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <Form.Label style={{ fontSize: 10 }}>تاریخ اخذ لیسانس</Form.Label>
                                            <div>
                                                <DatePicker inputClass={`datepicker`} direction="ltr" position="center" round={'x3'} onChange={(e) => handleSetDateLicense(e.value, item.id)} />
                                            </div>
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <Form.Label style={{ fontSize: 10 }}>زمینه کاری اعطا شده</Form.Label>
                                            <Form.Control className="input-pmk" placeholder="زمینه کاری اعطا شده" name="work" value={item.work} onChange={(e) => updateLicense(e, item.id)} type="text" />
                                        </Col>

                                    </Row>
                                    <Button onClick={(e) => removeLicense(item.id)} variant="danger" size="sm">حذف</Button>
                                    <hr />
                                </>
                            )
                        })
                    }
                    <Row>
                        <Col xs={12} className="mt-4">
                            <Button onClick={(e) => addLicense()} size="sm" >افزودن لایسنس جدید</Button>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} className="mt-4">
                    <Form.Group controlId="formFile3" className="mb-4">
                        <Form.Label>مستندات لیسانس شرکتهای معتبر / نمایندگی / مشارکت :(فرمت zip)</Form.Label>
                        <Form.Control disabled={startAttachLicense} onChange={(e) => UploadattachLicense(e)} type="file" size="sm" accept=".zip" />
                    </Form.Group>
                    {
                        attachLicense &&
                        <a target="_blank" rel="noreferrer" className="mb-2" href={url + attachLicense} download>نمایش فایل</a>
                    }
                </Col>



                <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                    <label className="text-g fw-bold">توان تجهيزاتي(ماشين ‌آلات.ابزار و تجهيزات خاص)</label>
                </Col>

                <Col xs={12} className="mt-4">

                    {
                        cars.map((item, index) => {
                            return (
                                <>
                                    <Row className="mb-3" key={index}>
                                        <Col xs={12} md={3}>
                                            <Form.Label style={{ fontSize: 10 }}>نام ابزار/ دستگاه/تجهیزات</Form.Label>
                                            <Form.Control className="input-pmk" placeholder="نام ابزار/ دستگاه/تجهیزات" name="name" value={item.name} onChange={(e) => updateCars(e, item.id)} type="text" />
                                        </Col>
                                        <Col xs={12} md={3}>
                                            <Form.Label style={{ fontSize: 10 }}>سال ساخت</Form.Label>
                                            <Form.Control className="input-pmk" placeholder="سال ساخت" name="year" value={item.year} onChange={(e) => updateCars(e, item.id)} type="text" />
                                        </Col>
                                        <Col xs={12} md={2}>
                                            <Form.Label style={{ fontSize: 10 }}>تعداد</Form.Label>
                                            <Form.Control className="input-pmk" placeholder="تعداد" name="count" value={item.count} onChange={(e) => updateCars(e, item.id)} type="text" />
                                        </Col>
                                        <Col xs={12} md={2}>
                                            <Form.Label style={{ fontSize: 10 }}>نوع مالکیت ملکی /اجاره ای</Form.Label>
                                            <Form.Control className="input-pmk" placeholder="نوع مالکیت ملکی /اجاره ای" name="type" value={item.type} onChange={(e) => updateCars(e, item.id)} type="text" />
                                        </Col>

                                        <Col xs={12} md={2}>
                                            <Form.Label style={{ fontSize: 10 }}>کشور سازنده</Form.Label>
                                            <Form.Control className="input-pmk" placeholder="کشور سازنده" name="country" value={item.country} onChange={(e) => updateCars(e, item.id)} type="text" />
                                        </Col>
                                    </Row>
                                    <Button onClick={(e) => removeCars(item.id)} variant="danger" size="sm">حذف</Button>
                                    <hr />
                                </>
                            )
                        })
                    }
                    <Row>
                        <Col xs={12} className="mt-4">
                            <Button onClick={(e) => addCars()} size="sm" >افزودن ماشین آلات جدید</Button>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} className="mt-4">
                    <Form.Group controlId="formFile3" className="mb-4">
                        <Form.Label>مستندات توان تجهيزاتي(ماشين ‌آلات.ابزار و تجهيزات خاص) :(فرمت zip)	</Form.Label>
                        <Form.Control disabled={startAttachCars} onChange={(e) => UploadattachCars(e)} type="file" size="sm" accept=".zip" />
                    </Form.Group>
                    {
                        attachCars &&
                        <a target="_blank" rel="noreferrer" className="mb-2" href={url + attachCars} download>نمایش فایل</a>
                    }
                </Col>
                <Col xs={12} className="mt-4 py-2" style={{ backgroundColor: '#1f3870', color: 'white' }}>
                    <label className="text-g fw-bold">*شرح فعالیت <sup style={{ color: 'red', fontSize: 13 }}>*</sup></label>
                    <p>
                        لطفا از وارد کردن متن طولانی و توضیحات اضافی خودداری نمایید.حداکثر طول قابل قبول 1000 کاراکتر می باشد.
                    </p>
                </Col>
                <Col xs={12} className="mt-4 py-2">
                    <Form.Group>
                        <Form.Control isInvalid={submit && descriptionPeymankar == ''} value={descriptionPeymankar} onChange={(e) => setDescriptionPeymankar(e.target.value)} as="textarea" rows={3} />
                    </Form.Group>
                </Col>

                <Col xs={12} className="mt-4 text-center">
                    <div className="d-grid gap-2">
                        <Button variant="success" onClick={() => changeStep()}>
                            مرحله بعد
                        </Button>
                        <Button variant="muted" className="mt-2" onClick={() => changeStepBack()}>
                            مرحله قبل
                        </Button>
                    </div>
                </Col>

            </Row>
        </Container>
    )
}